import { render, staticRenderFns } from "./FeedbackType.vue?vue&type=template&id=2f912a10&scoped=true"
import script from "./FeedbackType.vue?vue&type=script&lang=js"
export * from "./FeedbackType.vue?vue&type=script&lang=js"
import style0 from "./FeedbackType.vue?vue&type=style&index=0&id=2f912a10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f912a10",
  null
  
)

export default component.exports